export const defaultSorter =
  <T>(getter: (item: T) => string) =>
  (a: T, b: T) =>
    typeof getter(a) === 'string' && typeof getter(b) === 'string'
      ? getter(a).localeCompare(getter(b), undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      : 1;
